<button mat-button class="button-close" [mat-dialog-close]="true">
  <mat-icon class="white-icon">close</mat-icon>
</button>
<div class="dialog-content">
  <div class="content-header">Whats going on and How do I fix it?</div>
  <div class="content-main">
    <div class="content-main-text">
      <div>
        Hey <span>{{data.userName}}</span>, it looks like I haven't been able to see your patient data for two days.
        This can happen sometimes for a variety of reasons, but I need to get reconnected to your practice software to
        find new patients for followup.
      </div>
      <div>
        To help me get connected again, please send my support team an email at <span
          class="blue-text">support&#64;dentma.com</span> or send a text message to 888-947-6001 and they'll work with you
        to get me connected again. <br />
        <br />
        Thanks!
      </div>
    </div>
    <div class="ava-image-container">
      <img src="./assets/images/ava-connection-problem.svg" />
    </div>
  </div>
</div>
